var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backtest-macd-view"},[_c('BacktestMACD')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }